module.exports = __webpack_public_path__ + "img/list-icon.00d90879.png";